import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetListingAppendTypeActionType, TSetListingAppendType } from './types';
import { ISettings } from '../../../types/settings';

export const setListingAppendType: (type: ISettings['listingAppendType']) => TSetListingAppendType = actionGenerator<
  ESetListingAppendTypeActionType.Set,
  ISettings['listingAppendType']
>(ESetListingAppendTypeActionType.Set);
